<template>
  <div class="filter-panel-container">
    <slot></slot>
    <FilterContainer v-for="(filter, key) in filters" :key="key"
      :loading="loading"
      @openToggled="emitCollapseToggled">
      <template v-slot:filterName>
        <span>{{ filter.nameDisplay || filter.name }}</span>
      </template>
      <component
        :is="componentMap[filter.type]"
        v-model:filter="filters[key]"
        :loading="loading"
        :showUpTo="10"
        @showAllFacets="showAllFacets"
        :totalOptions="(filter as any).availableValues?.length"
        @userUpdatedFilter="handleFilterUpdate"/>
    </FilterContainer>
  </div>
</template>

<script setup lang="ts">
import { FilterContainer, SelectFilter, RangeFilter, DateRangeFilter } from 'VoyagerComponents';
import { useQueryStore } from '@/store/query';
import { ref, watch } from 'vue';

const { getAllFilters, getFacetsLoading } = useQueryStore();
let filters = getAllFilters();
let loading = ref(false);
const emit = defineEmits(['filterCollapseToggled', 'userUpdatedFilter', 'showAllFacets']);
const emitCollapseToggled = () => emit('filterCollapseToggled'),
handleFilterUpdate = (payload) => emit('userUpdatedFilter', payload),
showAllFacets = (fieldName) => emit('showAllFacets', fieldName);
const componentMap = {
    single: SelectFilter,
    multi: SelectFilter,
    range: RangeFilter,
    fileSize: RangeFilter,
    dateRange: DateRangeFilter
  };

watch(() => getAllFilters(), (newFilters) => filters = newFilters);
watch(() => getFacetsLoading, (next) => {
  loading.value = next
}, { immediate: true, deep: true });

</script>
<style scoped lang="scss">
.filter-panel-container {
  width: 98%;
  overflow-x: hidden;
  color: var(--color-text-primary)
}
</style>